import fr from 'facet-rest';
import { metaOverrideSet as DefaultStepMetaOverrideSet } from 'Views/Page/Content/Modal/Layouts/DefaultStep';
import NullComponent from 'Components/UI/NullComponent';
import DateOrYearPickerWhatIf from 'Components/ComponentLibrary/Molecules/dateOrYearPicker/whatIf';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';

export default fr.metaOverride({ base: DefaultStepMetaOverrideSet })
  .nameOverride('retirementDate', {
    _component: () => DateOrYearPickerWhatIf,
    _customProps: {
      startDateField: 'birthDate',
      yearLabel: 'Retirement Age',
    },
  }, overrideReadOnly)
  // This is marked as hidden on the backend via meta, but the frontend isn't respecting it :/ so I'm using this to make it not be hidden
  .nameOverride('birthDate', {
    _component: () => NullComponent,
  }, overrideReadOnly);
